import { render } from "./ClubsLanding.vue?vue&type=template&id=00b30c80"
import script from "./ClubsLanding.vue?vue&type=script&lang=js"
export * from "./ClubsLanding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__